import { CONTACT_TYPE_OPTIONS_API } from '@/mock/contactType';
import { INFLUENCER_TYPE_OPTIONS_API } from '@/mock/influencerType';
import { REGION_OPTIONS } from '@/mock/region';
import { ROLE_OPTIONS } from '@/mock/role';

type IndustryType = {
  [Key in (typeof CONTACT_TYPE_OPTIONS_API)[number]['value']]: (typeof CONTACT_TYPE_OPTIONS_API)[number]['label'];
};

const IndustryType: IndustryType = INFLUENCER_TYPE_OPTIONS_API.reduce((acc, { value }) => {
  acc[value] = value;
  return acc;
}, {} as IndustryType);

type ContactType = {
  [Key in (typeof CONTACT_TYPE_OPTIONS_API)[number]['value']]: (typeof CONTACT_TYPE_OPTIONS_API)[number]['label'];
};

const ContactType: ContactType = CONTACT_TYPE_OPTIONS_API.reduce((acc, { value }) => {
  acc[value] = value;
  return acc;
}, {} as ContactType);

type RoleType = {
  [Key in (typeof ROLE_OPTIONS)[number]['value']]: (typeof ROLE_OPTIONS)[number]['label'];
};

const RoleType: RoleType = ROLE_OPTIONS.reduce((acc, { value }) => {
  acc[value] = value;
  return acc;
}, {} as RoleType);

type RegionType = {
  [Key in (typeof REGION_OPTIONS)[number]['value']]: (typeof REGION_OPTIONS)[number]['label'];
};

const RegionType: RegionType = REGION_OPTIONS.reduce((acc, { value }) => {
  acc[value] = value;
  return acc;
}, {} as RegionType);

export { ContactType, RoleType, IndustryType, RegionType };
